<style src="./VehicleHistory.scss" lang="scss"></style>
<template>
  <section class="wrapper wrapper-content animated fadeIn">
    <div class="vehicle-identification">
      <form v-on:submit.prevent="loadVehicleHistory" class="mail-search">
        <div class="input-group">
          <input
            type="text"
            class="form-control input-md"
            v-model="vehicleForm.form.licencePlate"
            placeholder="Placa do veículo"
          />

          <div class="input-group-btn">
            <button type="submit" class="btn btn-sm btn-primary">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
        <div class="input-btn m-l-md" v-if="resetContinuityAvailable">
          <button
            type="button"
            class="btn btn-sm btn-danger"
            @click="resetContinuity"
          >
            <i class="fa fa-warning"></i>
            Resetar Cotinuidade
          </button>
        </div>
      </form>
    </div>

    <section class="timeline-container">
      <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

      <div
        class="timeline"
        v-for="(timelineItem, timelineIdx) in timeline"
        :key="timelineIdx"
      >
        <div
          class="timeline-row"
          :class="{ 'is-reversed': checkReversed(timelineIdx) }"
        >
          <div class="timeline-info">
            <template
              v-if="
                timelineItem.parkingHistory &&
                  timelineItem.parkingHistory.movement === 'entered'
              "
            >
              <div class="timeline-box credit-card">
                <credit-card
                  v-if="timelineItem.credit"
                  :info="timelineItem.credit"
                />
              </div>
              <div
                class="timeline-box notification-card"
                v-if="timelineItem.credit && timelineItem.credit.amountPaid < 0"
              >
                <notification-card :info="timelineItem.credit" />
              </div>

              <div
                class="timeline-box notification-card"
                v-if="
                  timelineItem.credit && timelineItem.credit.amountPaid === 0
                "
              >
                <aged-card :info="timelineItem.credit.photos" />
              </div>

              <div class="timeline-box parking-history-card">
                <parking-history-card
                  v-if="timelineItem.parkingHistory"
                  :info="timelineItem.parkingHistory"
                  :show-employee="!timelineItem.credit"
                />
              </div>
            </template>
          </div>

          <div class="timeline-date">
            <span class="reversal" v-show="checkReversed(timelineIdx)"
              >ESTORNO</span
            >
            <span class="date">
              {{ timelineIdx | dateBR }}
            </span>

            <span class="time">
              {{ timelineIdx | timeBR }}
            </span>

            <!-- <span class="time">
              {{ getElapsedTime(timelineIdx)}}
            </span> -->
          </div>

          <div class="timeline-info">
            <template
              v-if="
                !timelineItem.parkingHistory ||
                  (timelineItem.parkingHistory &&
                    timelineItem.parkingHistory.movement !== 'entered')
              "
            >
              <div class="timeline-box parking-history-card">
                <parking-history-card
                  v-if="timelineItem.parkingHistory"
                  :info="timelineItem.parkingHistory"
                />
              </div>
              <!-- <div class="timeline-box notification-card">
                <notification-card v-if="timelineItem.notification" :info="timelineItem.notification" />
              </div> -->

              <div class="timeline-box credit-card">
                <credit-card
                  v-if="timelineItem.credit"
                  :info="timelineItem.credit"
                />
              </div>
            </template>
          </div>
        </div>

        <!-- {{ timelineItem.parkingHistory }} -->
        <div
          class="separated-line"
          v-if="
            !timelineItem.parkingHistory ||
              timelineItem.parkingHistory.movement !== 'entered'
          "
        ></div>
        <div
          class="separated-line-ghost"
          v-if="
            timelineItem.parkingHistory &&
              timelineItem.parkingHistory.movement === 'entered'
          "
        ></div>
      </div>
    </section>
  </section>
</template>

<script>
import FormatTimeline from './helpers/FormatTimeline';
import CreditCard from './components/CreditCard';
import NotificationCard from './components/NotificationCard';
import AgedCard from './components/AgedCard';
import ParkingHistoryCard from './components/ParkingHistoryCard';
import Spinner from '../../components/Spinner';
import moment from 'moment';

export default {
  name: 'VehicleHistory',
  components: {
    CreditCard,
    NotificationCard,
    AgedCard,
    ParkingHistoryCard,
    Spinner,
  },
  data() {
    return {
      resetContinuityAvailable: false,
      showSpinner: false,
      vehicleForm: {
        form: {
          licencePlate: '',
        },
      },
      timeline: [],
    };
  },
  filters: {
    dateBR(v) {
      return moment(new Date(v)).format('DD/MM/YYYY');
    },
    timeBR(v) {
      return moment(new Date(v)).format('HH:mm:ss');
    },
  },
  mounted() {
    const { licencePlate } = this.$route.params;
    this.loadWithUrlParam({ licencePlate });
  },
  methods: {
    async resetContinuity() {
      try {
        this.resetContinuityAvailable = false;
        await this.$store.dispatch('VEHICLE/ResetContinuity', {
          licencePlate: this.vehicleForm.form.licencePlate,
        });
        this.$toasted.success('Veículo resetado com sucesso');
      } catch (error) {
        this.$toasted.error('Erro ao resetar continuidade');
      } finally {
        this.loadVehicleHistory();
      }
    },
    loadWithUrlParam({ licencePlate }) {
      if (!licencePlate) return false;
      this.vehicleForm.form.licencePlate = licencePlate;
      this.loadVehicleHistory();
    },
    async loadVehicleHistory() {
      try {
        this.showSpinner = true;
        const payload = {
          licencePlate: this.vehicleForm.form.licencePlate,
        };

        const history = await this.$store.dispatch(
          'VEHICLE/GetHistory',
          payload,
        );
        this.checkContinuityResetAvailable(history);
        const formattedTimeline = FormatTimeline(history);
        this.timeline = formattedTimeline;
      } catch (error) {
        console.error(error);
      } finally {
        this.showSpinner = false;
      }
    },
    checkContinuityResetAvailable({ vehicle }) {
      const isParked = vehicle.isParked;
      const hasContinuity =
        vehicle.continuousParking && !!vehicle.continuousParking.length;

      if (!isParked && hasContinuity) {
        return (this.resetContinuityAvailable = true);
      }
      this.resetContinuityAvailable = false;
    },
    checkReversed(timelineIdx) {
      const actualReversed = this.timeline[timelineIdx].credit
        ? this.timeline[timelineIdx].credit.isReversed
        : false;

      const timelineKeys = Object.keys(this.timeline);
      const actualIndex = timelineKeys.indexOf(timelineIdx);
      const afterItemKey =
        actualIndex < timelineKeys.length - 1
          ? timelineKeys[actualIndex + 1]
          : timelineKeys[timelineKeys.length - 1];

      const prevReversed =
        this.timeline[afterItemKey] && this.timeline[afterItemKey].credit
          ? this.timeline[afterItemKey].credit.isReversed
          : false;
      return actualReversed || prevReversed;
    },
  },
};
</script>
